import { CalendarDesigner } from './CalendarDesigner.js';
import type { Designer } from './Designer.js';
import { MultiSurfaceDesigner } from './MultiSurfaceDesigner.js';
import { PhotobookDesigner } from './PhotobookDesigner.js';
import { PrintsDesigner } from './PrintsDesigner.js';
import type { CropType, IPhoto, IProject } from '../common/index.js';

export function createDesigner(project: IProject, photos: IPhoto[], cropStrategy?: CropType): Designer {
    switch (project.type) {
        case 'cards':
        case 'singlesurface':
            // fall through

        case 'multisurface': {
            return new MultiSurfaceDesigner(project, photos, cropStrategy);
        }

        case 'prints': {
            return new PrintsDesigner(project, photos, cropStrategy);
        }

        case 'calendar': {
            return new CalendarDesigner(project, photos, cropStrategy);
        }

        case 'books': {
            return new PhotobookDesigner(project, photos, cropStrategy);
        }

        default: {
            throw new Error(`Designer type "${String(project.type)}" is not supported.`);
        }
    }
}
